//#region index.ts
/** Copies `content` to the clipboard, which can be text, images or an array of these */
async function clippie(content, { reject = false } = {}) {
	try {
		if (Array.isArray(content)) {
			if (!navigator?.clipboard?.write) {
				for (const c of content) if (typeof c === "string") {
					const result = fallback(c);
					if (!result) return result;
				}
				return true;
			}
			await navigator.clipboard.write([new ClipboardItem(Object.fromEntries(content.map((c) => {
				if (c instanceof Blob) return [c.type ?? "text/plain", c];
				else return ["text/plain", c];
			})))]);
			return true;
		} else if (content instanceof Blob) {
			await navigator.clipboard.write([new ClipboardItem({ [content.type]: content })]);
			return true;
		} else try {
			await navigator.clipboard.writeText(String(content));
			return true;
		} catch {
			return fallback(content);
		}
	} catch (err) {
		if (reject) throw err;
		return false;
	}
}
function fallback(content) {
	if (!document.execCommand) return false;
	const el = document.createElement("textarea");
	el.value = String(content);
	el.style.clipPath = "inset(50%)";
	el.ariaHidden = "true";
	document.body.append(el);
	try {
		el.select();
		return document.execCommand("copy");
	} finally {
		el.remove();
	}
}

//#endregion
export { clippie };
//# sourceMappingURL=index.js.map